import { render, staticRenderFns } from "./OppleAbilityWifi.vue?vue&type=template&id=754608f2"
import script from "./OppleAbilityWifi.vue?vue&type=script&lang=js"
export * from "./OppleAbilityWifi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@2.8.8_vue-template-compiler@2.7.16_webpack@5.101.3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports